// extracted by mini-css-extract-plugin
module.exports = {"root":"PinnedSideBar_root__2NiWJ","header":"PinnedSideBar_header__2CegB","title":"PinnedSideBar_title__sFA8U"};